import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const NABIL_AUCTION_API = `${API_URL}/nabil-auction`

export const service = {
  getNabilAuction: (params: ParamsModel) => {
    return axios.get(NABIL_AUCTION_API, {params})
  },
  addNabilAuction: (data: any) => {
    return axios.post(NABIL_AUCTION_API, data)
  },
  updateNabilAuction: (body: any, id: string) => {
    return axios.put(`${NABIL_AUCTION_API}/${id}`, body)
  },
  deleteNabilAuction: (data: {ids: string[]}) => {
    return axios.delete(`${NABIL_AUCTION_API}/bulk-delete`, {data})
  },
  enableNabilAuction: (data: Array<string>) => {
    return axios.patch(`${NABIL_AUCTION_API}/enable`, {ids: data})
  },
  disableNabilAuction: (data: Array<string>) => {
    return axios.patch(`${NABIL_AUCTION_API}/disable`, {ids: data})
  },
  singleEnableNabilAuction: (data: string) => {
    return axios.patch(`${NABIL_AUCTION_API}/enable`, {ids: [data]})
  },
  singleDisableNabilAuction: (data: string) => {
    return axios.patch(`${NABIL_AUCTION_API}/disable`, {ids: [data]})
  },
  getNabilAuctionCategoryList: () => {
    return axios.get(`${NABIL_AUCTION_API}/category-list`)
  },
}
